<template>
  <div ref="container">
    <a-modal
      title="会员档案详情"
      :width="860"
      :visible="visible"
      :footer="null"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      @cancel="close"
      style="top:100px;">
      <a-spin :spinning="loading">
        <a-card size="small" title="基本信息" :bordered="true" style="margin-bottom:12px">
          <a-descriptions :column="3" size="small">
            <a-descriptions-item label="会员卡号">{{ detail.supplierName || '-' }}</a-descriptions-item>
            <a-descriptions-item label="当前等级">
              <a-tag v-if="detail.levelName" color="blue">{{ detail.levelName }}</a-tag>
              <span v-else>-</span>
            </a-descriptions-item>
            <a-descriptions-item label="预付款余额">{{ detail.advanceIn || 0 }}</a-descriptions-item>
            <a-descriptions-item label="累计零售实付">{{ detail.consume_total || 0 }}</a-descriptions-item>
            <a-descriptions-item label="本周期消费">{{ detail.period_consume || 0 }}</a-descriptions-item>
            <a-descriptions-item label="周期">{{ detail.period_start ? (detail.period_start + ' ~ ' + (detail.period_end || '')) : '-' }}</a-descriptions-item>
          </a-descriptions>
        </a-card>
        <a-card size="small" title="消费汇总（已审核零售单）" :bordered="true" style="margin-bottom:12px">
          <span>零售合计：{{ detail.retailTotal || 0 }}　　退货合计：{{ detail.returnTotal || 0 }}　　净消费：{{ netConsume }}</span>
        </a-card>
        <a-card size="small" title="手动调级" :bordered="true" style="margin-bottom:12px">
          <a-row :gutter="12">
            <a-col :span="8">
              <a-select style="width:100%" placeholder="选择目标等级" v-model="targetLevelId">
                <a-select-option v-for="lv in levels" :key="lv.id" :value="lv.id">{{ lv.name }}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="12">
              <a-input placeholder="调级原因（选填，记入日志）" v-model="levelReason" />
            </a-col>
            <a-col :span="4">
              <a-button type="primary" :disabled="!targetLevelId" @click="handleLevelChange">调级</a-button>
            </a-col>
          </a-row>
        </a-card>
        <a-card size="small" title="会员卡（收银台扫码识别会员）" :bordered="true" style="margin-bottom:12px">
          <div style="text-align:center">
            <img v-if="cardBase64" :src="'data:image/png;base64,' + cardBase64" style="width:220px;height:220px" alt="会员卡二维码" />
            <a-button style="margin-left:16px" @click="loadCard">显示会员卡</a-button>
          </div>
        </a-card>
        <a-card size="small" title="近期零售单（最近 20 笔）" :bordered="true">
          <a-table
            size="small"
            bordered
            rowKey="id"
            :columns="orderColumns"
            :dataSource="detail.recentOrders || []"
            :pagination="false">
          </a-table>
        </a-card>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { memberDetail, memberUpdateLevel, memberCard, levelList } from '@/api/plugin/member'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'MemberDetailModal',
  mixins: [mixinDevice],
  data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      levels: [],
      targetLevelId: undefined,
      levelReason: '',
      cardBase64: '',
      orderColumns: [
        { title: '单据编号', dataIndex: 'number', width: 160 },
        { title: '类型', dataIndex: 'sub_type', width: 80 },
        { title: '金额', dataIndex: 'total_price', width: 100, align: 'right' },
        { title: '支付方式', dataIndex: 'pay_type', width: 100 },
        { title: '日期', dataIndex: 'create_time', width: 160 }
      ]
    }
  },
  computed: {
    netConsume() {
      const retail = parseFloat(this.detail.retailTotal || 0)
      const back = parseFloat(this.detail.returnTotal || 0)
      return (retail - back).toFixed(2)
    }
  },
  methods: {
    show(record) {
      this.visible = true
      this.detail = {}
      this.cardBase64 = ''
      this.targetLevelId = undefined
      this.levelReason = ''
      if (!record.memberId) {
        this.$message.warning('该会员尚未初始化等级档案，请稍候（约 60 秒自动初始化）')
        return
      }
      this.loadDetail(record.memberId)
      this.loadLevels()
    },
    loadDetail(memberId) {
      this.loading = true
      memberDetail(memberId).then((res) => {
        if (res.code === 200) {
          this.detail = res.data || {}
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadLevels() {
      levelList().then((res) => {
        if (res.code === 200) {
          this.levels = (res.data && res.data.rows) || []
        }
      })
    },
    loadCard() {
      if (!this.detail.id) {
        return
      }
      memberCard(this.detail.id).then((res) => {
        if (res.code === 200) {
          this.cardBase64 = res.data.qrBase64
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleLevelChange() {
      const that = this
      this.$confirm({
        title: '确认调级',
        content: '调整后保级周期将重新起算（12 个月），确定继续？',
        onOk() {
          memberUpdateLevel(that.detail.id, { levelId: that.targetLevelId, reason: that.levelReason }).then((res) => {
            if (res.code === 200) {
              that.$message.success(res.message)
              that.loadDetail(that.detail.id)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    close() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
</style>
